import { AxiosResponse } from 'axios';
import WbHttpClient from '../../services/wbhttpclient';

export default class KRService extends WbHttpClient {
    /**
   * get edit metric data
   * @param params
   */
    public getEditMetricData (params = {}): Promise<AxiosResponse> {
        return this.get('goal/editMetricData', params);
    }

    /**
   * get MIT overlay series (value + target + interval) for a KR's chart
   * @param params
   */
    public getKrGraphData (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getKrGraphData', params);
    }

    /**
   * save metric data
   * @param params
   */
    public saveMetricData(params = {}): Promise<AxiosResponse> {
        return this.post('goal/metricDataSubmit', params).then((response) => {
            if (response.data && response.data.success) {
                const channel = new BroadcastChannel('okr:keyResultUpdated');
                // @ts-ignore
                channel.postMessage(params.metricId);
            }
            return response;
        });
    }

    /**
   * save metric status
   * @param params
   */
    public saveMetricStatus (params = {}): Promise<AxiosResponse> {
        return this.post('goal/updateMetricUpdateStatus', params)
    }

    public getOkrPopUpTabs (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getGoalDetailsPopUpMenu', params);
    }

    public getOkrPopUpCategary (params = {}) : Promise<AxiosResponse> {
        return this.get('goal/getGoalDetailsPopUpCat', params);
    }

    public getGoalComments (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getGoalComments', params);
    }

    public getGoalReviewComments (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getGoalReviewComments', params);
    }

    public getGoalMetrics (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getGoalMetrics', params);
    }

    public goalAlignmentSearch (params = {}): Promise<AxiosResponse> {
        return this.get('goal/goalAlignmentSearch?json', params);
    }

    public getGoalWs (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getGoalWs', params);
    }

    public getOKRHistory (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getOKRHistory', params);
    }

    public saveComment (params = {}): Promise<AxiosResponse> {
        return this.post('goal/saveGoalComment', params);
    }

    public getGoalAlignmentSearch (params = {}): Promise<AxiosResponse> {
        return this.post('goal/goalAlignmentSearch?json', params);
    }

    public deleteUserFavorites (params = {}): Promise<AxiosResponse> {
        return this.post('workboard/deleteUserFavorites', params);
    }

    public addRbrGoal (params = {}): Promise<AxiosResponse> {
        return this.get('rbr/addRbrGoal', params);
    }

    public addUserFavorites (params = {}): Promise<AxiosResponse> {
        return this.post('workboard/addUserFavorites', params);
    }

    public getMetricGoals (params = {}):Promise<AxiosResponse> {
        return this.get('goal/getMetricGoals', params);
    }

    public setGoalDetailsEvent (params = {}): Promise<AxiosResponse> {
        return this.post('goal/goalDetailsEvents', params);
    }

    public getMetricChartData (params = {}): Promise<AxiosResponse> {
        return this.get('goal/getMetricChartData', params);
    }

    public getUserAndTeamData (params = {}): Promise<AxiosResponse> {
        return this.get('workboard/getRelatedMembers', params);
    }
    
}
